import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthTokenSync } from './AuthTokenSync';
import { ImpersonationWrapper } from './ImpersonationWrapper';
import { StoreOrgId } from './StoreOrgId';
import { ViewerProfileProvider } from './ViewerProfileContext';
import { AuthKitProvider } from '@workos-inc/authkit-react';

import { useAppNavigate } from '@/router/useAppNavigate';
import { sanitizeInternalReturnPath } from '@/utils/authReturnPath';

import { RoutesEnum } from '../enums';

export const AuthKitWrapper: FC = () => {
  const navigate = useAppNavigate();

  return (
    <AuthKitProvider
      clientId={import.meta.env.VITE_WORKOS_CLIENT_ID}
      redirectUri={import.meta.env.VITE_WORKOS_REDIRECT_URI}
      onRedirectCallback={params => {
        const returnTo = sanitizeInternalReturnPath(params.state?.returnTo);

        if (params.organizationId) {
          navigate(returnTo, { replace: true });
        } else {
          navigate(RoutesEnum.ONBOARDING, { replace: true });
        }
      }}
      devMode={import.meta.env.VITE_WORKOS_DEVMODE === 'true'}
    >
      <AuthTokenSync>
        <StoreOrgId />
        <ImpersonationWrapper />
      </AuthTokenSync>
      <ViewerProfileProvider>
        <Outlet />
      </ViewerProfileProvider>
    </AuthKitProvider>
  );
};
